import React from 'react';

import { PageLayout } from 'src/components/common';
import { PeosTablePeoPayrollProvider } from 'src/components/peo';
import { spacingStyling } from 'src/constants/spacing';
import { useFilterStorage } from 'src/hooks/common';
import { usePeosList, usePeosUnderPeoPpListQueryVariables } from 'src/hooks/peo';
import { InvitePeoByPeoPpModal } from 'src/modals/peo';
import { TableDataProvider } from 'src/providers/TableDataProvider';
import { SxProp } from 'src/types/mui';

export const PeosPagePeoPayrollProvider = () => {
  const { pagination } = useFilterStorage();
  const { queryFilter, sortQueryVariable, paginationQueryVariables } =
    usePeosUnderPeoPpListQueryVariables();

  const { peosList, peosCount, loading, refetch } = usePeosList(
    queryFilter,
    sortQueryVariable,
    paginationQueryVariables,
    true,
  );

  const refetchData = React.useCallback(async () => {
    await refetch();
    pagination.resetPage();
  }, [pagination, refetch]);

  return (
    <PageLayout titleContent="PEOs" paperSx={pageLayoutPaperSx}>
      <TableDataProvider>
        <PeosTablePeoPayrollProvider
          peosList={peosList}
          peosCount={peosCount}
          loading={loading}
          onRefresh={refetchData}
          pagination={pagination}
        />
        <InvitePeoByPeoPpModal />
      </TableDataProvider>
    </PageLayout>
  );
};

const pageLayoutPaperSx: SxProp = {
  p: spacingStyling.peoTable,
  mt: 5,
};
